module.exports = __webpack_public_path__ + "static/img/3.ebd8914.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/3.jpg
// module id = 196
// module chunks = 1